export default __webpack_public_path__ + "static/media/comment.23b24084.svg";